import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/routeNumbers`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, routeNumberId) {
      const response = await axios.get(`${API_URL}/routeNumbers/${routeNumberId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, routeNumber) {
      const response = await axios.post(`${API_URL}/routeNumbers`, routeNumber);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { routeNumberId, routeNumberData }) {
      const response = await axios.put(`${API_URL}/routeNumbers/${routeNumberId}`, routeNumberData);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, routeNumberId) {
      const response = await axios.delete(`${API_URL}/routeNumbers/${routeNumberId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getOptions(_, criteria = {}) {
      const response = await axios.get(`${API_URL}/routeNumbers/options`, {
        params: criteria,
      });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },
  },
};
